import React, { Fragment } from "react";
import { Link, NavLink } from "react-router-dom";
import { Popover, Transition } from "@headlessui/react";
import { MenuIcon, XIcon } from "@heroicons/react/outline";
import Card, { Data } from "./Card";
import mafs from "../assets/mafs.jpg";

const navigation = [
  { name: "Home", href: "/", current: true },
  { name: "Quiz", href: "/quiz", current: false },
  { name: "About Me", href: "/about", current: false },
  { name: "Contact Me", href: "/contact", current: false },
];

function ncard(val) {
  return (
    <Card key={val.title} title={val.title} desc={val.desc} url={val.url} />
  );
}

export default function Hero() {
  return (
    <>
      <div className="relative bg-background overflow-hidden">
        <div className="max-w-7xl mx-auto">
          <div className="relative z-10 pb-8 bg-background sm:pb-16 md:pb-20 lg:max-w-2xl lg:w-full lg:pb-28 xl:pb-32">
            <svg
              className="hidden lg:block absolute right-0 inset-y-0 h-full w-48 text-background transform translate-x-1/2"
              fill="currentColor"
              viewBox="0 0 100 100"
              preserveAspectRatio="none"
              aria-hidden="true"
            >
              <polygon points="50,0 100,0 50,100 0,100" />
            </svg>
            <Popover>
              {({ open }) => (
                <>
                  <div className="relative pt-6 px-4 sm:px-6 lg:px-8">
                    <nav
                      className="relative flex items-center justify-between sm:h-10 lg:justify-start"
                      aria-label="Global"
                    >
                      <div className="flex items-center flex-grow flex-shrink-0 lg:flex-grow-0">
                        <div className="flex items-center justify-between w-full md:w-auto">
                          <Link
                            className="text-4xl text-snow-storm-white pb-1"
                            to="/"
                          >
                            <span className="sr-only">Workflow</span>
                            Mafs
                          </Link>
                          <div className="-mr-2 flex items-center md:hidden">
                            <Popover.Button className="rounded-md p-2 inline-flex items-center justify-center text-white focus:outline-none">
                              <span className="sr-only">Open main menu</span>
                              <MenuIcon
                                className="h-6 w-6"
                                aria-hidden="true"
                              />
                            </Popover.Button>
                          </div>
                        </div>
                      </div>
                      <div className="hidden md:block md:ml-10 md:pr-4 md:space-x-8">
                        {navigation.map((item) => (
                          <NavLink
                            key={item.name}
                            to={item.href}
                            className="font-medium text-snow-storm-white p-2 rounded-md hover:bg-hoverGrey"
                          >
                            {item.name}
                          </NavLink>
                        ))}
                      </div>
                    </nav>
                  </div>

                  <Transition
                    show={open}
                    as={Fragment}
                    enter="duration-150 ease-out"
                    enterFrom="opacity-0 scale-95"
                    enterTo="opacity-100 scale-100"
                    leave="duration-100 ease-in"
                    leaveFrom="opacity-100 scale-100"
                    leaveTo="opacity-0 scale-95"
                  >
                    <Popover.Panel
                      focus
                      static
                      className="absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden"
                    >
                      <div className="rounded-lg shadow-md ring-1 ring-black ring-opacity-5 overflow-hidden bg-background">
                        <div className="px-5 pt-4 flex items-center justify-between">
                          <div className="text-4xl text-snow-storm-white">
                            Mafs
                          </div>
                          <div className="-mr-2">
                            <Popover.Button className="rounded-md p-2 inline-flex items-center justify-center text-white focus:outline-none">
                              <span className="sr-only">Close main menu</span>
                              <XIcon className="h-6 w-6" aria-hidden="true" />
                            </Popover.Button>
                          </div>
                        </div>
                        <div className="px-2 pt-2 pb-3 space-y-1">
                          {navigation.map((item) => (
                            <NavLink
                              key={item.name}
                              to={item.href}
                              className="block px-3 py-2 rounded-md text-base font-medium text-snow-storm-white"
                            >
                              {item.name}
                            </NavLink>
                          ))}
                        </div>
                      </div>
                    </Popover.Panel>
                  </Transition>
                </>
              )}
            </Popover>

            <main className="mt-10 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 xl:mt-28">
              <div className="sm:text-center lg:text-left">
                <h1 className="text-4xl tracking-tight font-extrabold text-snow-storm-white sm:text-5xl">
                  <span className="block xl:inline">
                    Mathematics is All About
                  </span>{" "}
                  <span className="block text-aurora-red xl:inline">
                    Learning By Doing
                  </span>
                </h1>
                <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0">
                  "Do not worry too much about your difficulty in mathematics, I
                  can assure you that mine are still greater." ~ Albert Einstein
                </p>
              </div>
            </main>
          </div>
        </div>
        <div className="lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
          <img
            className="h-56 w-full sm:h-72 md:h-96 lg:w-full lg:h-full"
            src={mafs}
            alt="Mafs"
          />
        </div>
      </div>
      <div className="flex grid grid-cols-1 lg:grid-cols-2 gap-4 bg-background overflow-hidden">
        {Data.map(ncard)}
      </div>
    </>
  );
}
